import { Alert, Button, Card, Form, InputGroup, OverlayTrigger, Table, Tooltip } from "react-bootstrap"
import { searchBarPlaceholder } from "./ListTypes";
import { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useAppSelector } from "../../../redux/hooks";
import { lddGlobalSessionInfo } from "../../../Components/navigationTypes";
import { FormListItem, handleSetData } from "./ListFuncs";
import { setFormListDataState } from "../../../redux/reducer";
import { useDispatch } from "react-redux";
import "../../../Components/List/List.css";

const List = <T extends unknown>(props: any) => {
    const dispatch = useDispatch();
    const [searchText, setSearchText] = useState<string>("");
    const [dataPage, setDataPage] = useState<number>(1);
    const [hasMoreData, setHasMoreData] = useState<boolean>(true);
    const [searchData, setSearchData] = useState<FormListItem[]>([]);
    const data: FormListItem[] = useAppSelector(g => g.ListData[props.listName]);
    
    const SESSION_INFO: lddGlobalSessionInfo = useAppSelector((g) => g.SessionInfo);
   
    function handleLoadData(): Promise<any[]> {
        return props.handleLoadFileData(SESSION_INFO.firm.id, SESSION_INFO.sid, props.LSUCID);
    }

    async function refreshData() {
        setSearchData([]);
        const data = await handleLoadData();
        handleSetData(props.listName, data, setData, setHasMoreData, setSearchData);
    }

    useEffect(() => {
        // lawyer status loaded
        if (props.loaded) {
            refreshData();
        }
    }, [props.loaded])

    useEffect(() => {
        if (props.LSUCID <= "") {
            refreshData();
        }
    }, [props.LSUCID])

    useEffect(() => {
        if (searchText > "") {
            // filter search
            const filteredData = data.filter((formItem) => {
                return formItem.FileName.toLowerCase().includes(searchText.toLowerCase()) || formItem.FileNum == searchText;
            });
            setSearchData(filteredData);
        } else {
            setSearchData(data);
        }
    }, [searchText])

    function setData(newData: FormListItem[]) {
        dispatch(setFormListDataState(props.listName, newData));
    }

    const HeadPart = () => (
        <>
            <InputGroup id="searchInputCol" className="search-bar">
                <InputGroup.Text>
                    <i style={{ cursor: "default" }} className="fa-light fa-magnifying-glass fa-indicator"></i>
                </InputGroup.Text>
                <Form.Control id="fileSearchInput" placeholder={`Type to search for an ${searchBarPlaceholder[props.listName]}..`} autoComplete={"off"} className="form-filter"
                    value={searchText}
                    onChange={(e) => {
                        setSearchText(e.target.value);
                    }}
                >
                </Form.Control>
                
                <div className="buttons-container">
                {searchText > "" &&
                    <OverlayTrigger placement="bottom" overlay={<Tooltip>Clear search</Tooltip>}>
                        <Button variant="link" id="clearSearchBtn" onClick={() => {
                            if (searchText !== '') {
                                setSearchText("");
                            }
                        }}>
                            <i id="clearSearchBtn2" className="fa-light fa-xmark"></i>
                        </Button>
                    </OverlayTrigger>
                }
                </div>
            </InputGroup>
        </>
    )

    const BodyPart = () => (
        <InfiniteScroll
            dataLength={searchData.length}
            scrollThreshold={0.7}
            next={async () => {
                const data = await handleLoadData();
                handleSetData(props.listName, data, setData, setHasMoreData, setSearchData);
            }}
            loader={(
                <p style={{ textAlign: "center" }}>
                    <b>Loading...</b>
                </p>
            )}
            height={400}
            hasMore={hasMoreData}
            scrollableTarget={props.listContainerID || "ListSection"}
            endMessage={(!props.notShowEndMessage && props.subscribed &&
                <Alert variant="primary" style={{ margin: "0 5px 5px", padding: "3px", textAlign: "center" }}><i>- {(data.length > 0 || searchData.length > 0) ? 'End of Results' : 'No Search Results Found'} -</i></Alert>
            )}
        >
            <Table hover>
                <thead>{props.buildHead(props.FileListColumns)}</thead>
                <tbody>
                    {
                    searchData.map(props.buildFileListLink(
                            props.FileListColumns,
                            searchText
                        ))
                    }
                </tbody>
            </Table>
        </InfiniteScroll>
    )
    
    return (
        <Card className={props.subscribed ?  "card-list card-search" : "card-list"}>
            <Card.Header>
                {props.subscribed ? HeadPart() : 
                    <Card.Title>OREA Forms</Card.Title>
                }
            </Card.Header>

            <Card.Body id={props.listContainerID || "ListSection"} className="ListSection">
                {BodyPart()}
            </Card.Body>
        </Card>
    )
}

export default List;